// src/lib/travelHealth/coAdmin/findRuleType.ts
//
// Resolves the rule "type" for a constraint by cross-referencing
// CO_ADMIN_RULES. CoAdminConstraint (the engine's output type) does not carry
// a `type` field — this is a read-only, presentation-layer lookup against
// the existing rules data and does not modify coAdminRules.ts or the engine.

import { CO_ADMIN_RULES, type CoAdminRuleType } from "./coAdminRules";
import type { CoAdminConstraint } from "../types/travelHealth.types";

export function findRuleType(
  constraint: CoAdminConstraint,
): CoAdminRuleType | null {
  const match = CO_ADMIN_RULES.find((rule) => {
    if (rule.pgdIdA !== constraint.pgdIdA) return false;
    if (rule.pgdIdB === null) return constraint.pgdIdB === "multiple";
    return rule.pgdIdB === constraint.pgdIdB;
  });
  return match ? match.type : null;
}
